import MenuList from '@mui/material/MenuList';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import useIsMobile from 'lib/useIsMobile';

const styles = {
  list: {
    paddingTop: 10,
    paddingBottom: 10,
  },
  menu: { width: '100%' },
};
const PageMenu = ({ children, style, ...props }) => {
  const mobile = useIsMobile();
  return (
    <MenuList
      {...props}
      desktop={!mobile}
      style={useMemo(
        () => ({
          ...styles.list,
          ...styles.menu,
          ...style,
        }),
        [style],
      )}
    >
      {children}
    </MenuList>
  );
};

PageMenu.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
};

export default PageMenu;
